module.exports = __webpack_public_path__ + "img/kazakov.da039f1a.jpg";